import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { BiBuildings } from 'react-icons/bi';
import ButtonClose from 'utils/buttons/ButtonClose';

const InfoBuilderModal = ({ builder, show, setShow }) => {
  return (
    <Modal centered show={show} onHide={() => setShow(false)}>
      <Modal.Header closeButton>
        <Modal.Title>
          <BiBuildings />
          <strong> Datos de la constructora</strong>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="m-0">
          Nombre: <strong>{builder?.name}</strong>
        </p>

        <p className="m-0 mt-2">
          Fecha de entrega: <strong>{builder?.deadline}</strong>
        </p>

        <p className="m-0 mt-2">
          Estado del emprendimiento: <strong>{builder?.project_status}</strong>
        </p>

        {builder?.observations && (
          <>
            <h5 className="mt-4">Observaciones:</h5>{' '}
            <p className="m-0">{builder?.observations}</p>
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <ButtonClose
          text="Cerrar"
          funcion={() => setShow(false)}
          variant="secondary"
        />
      </Modal.Footer>
    </Modal>
  );
};

InfoBuilderModal.propTypes = {
  builder: PropTypes.object,
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired
};

export default InfoBuilderModal;
